import { useEffect, useState } from 'react';
import { adminApi } from '@/features/admin/api/adminApi';
import type { EventDto } from '@/shared/types/domain';

const STORAGE_KEY = 'leadcapture.admin.selectedEventId';

export function useSelectedEvent() {
  const [events, setEvents] = useState<EventDto[]>([]);
  const [eventId, setEventIdState] = useState<string | null>(() => localStorage.getItem(STORAGE_KEY));
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    adminApi.events
      .list()
      .then((list) => {
        setEvents(list);
        // If nothing selected yet (or the previously-selected event no
        // longer exists), default to the most recent one so admin pages
        // always have a usable scope rather than an empty state on first load.
        setEventIdState((current) => {
          if (current && list.some((e) => e.id === current)) return current;
          return list[0]?.id ?? null;
        });
      })
      .finally(() => setIsLoading(false));
  }, []);

  function setEventId(id: string) {
    localStorage.setItem(STORAGE_KEY, id);
    setEventIdState(id);
  }

  return { events, eventId, setEventId, isLoading };
}
